import { Component } from '@angular/core';

@Component({
    selector: 'app-menu',
    standalone: false,
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss'
})
export class MenuComponent
{
    isMenuOpen = false;

    toggleMenu()
    {
        this.isMenuOpen = !this.isMenuOpen;
    }

    closeMenu()
    {
        this.isMenuOpen = false;
    }
}
